import { useLayoutEffect, useState } from 'react';
import { safeLocalStorage } from '../../utils/safeLocalStorage';
import useWidgetContext from '../useWidgetContext';

const SESSION_ID_STORAGE_KEY = 'dhUw_sessionId';

const useSessionId = (): string | null => {
  const { accountId } = useWidgetContext();
  const scopedSessionKey = `${SESSION_ID_STORAGE_KEY}__${accountId}`;
  const [sessionId, setSessionId] = useState(
    safeLocalStorage.getItem(scopedSessionKey),
  );

  useLayoutEffect(() => {
    if (sessionId) return;

    const timestamp = Date.now();
    const sessionString = `${timestamp}`;

    const generatedId = btoa(
      Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15) +
        sessionString,
    );

    safeLocalStorage.setItem(scopedSessionKey, generatedId);
    setSessionId(generatedId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return sessionId;
};

export default useSessionId;
